<template>
    <div id="ReportIframeBody">
          <div class="b-sidebar-backdrop bg-dark" style="z-index: 100" v-show="showIframe" @click="HideSideBar" ref="BackDrop"></div>
          <b-sidebar id="ReportIframe"  title="" right bg-variant="white" v-model="showIframe" 
                 :shadow="true" 
                ref="ReportIframe">
                    <span :class="`StatusPill Status_${this.reportIframeItem.StatusCode}`+' btnStyle'">
                        {{ $t(`lbl_EMPBE_AutoReport_${this.reportIframeItem.StatusCode}`)  }}
                    </span>
                    <div class="row col-6">
                              <selection :value="ReportSelectId" class="w-100 ReportSelectType" v-model="ReportSelectId"  
                                :options="ReportSelectOption"
                                :clearable="false" :multiple="false"
                                :preselect-first="true" style="    margin-top: 16px;margin-left: 15px">
                              </selection>

                    </div>
                          <iframe
                            width="100%"
                            height="800px"
                            :src="ReportUrl"
                          ></iframe>
    
       </b-sidebar>
    </div>
</template>

<script>

import DialogModal from '../../../components/popup/dialogModal.vue'

export default {
    props: ['reportIframeItem','isSuperAdmin'],
    components: {
        DialogModal
    },
    data() {
       return {
              showIframe:false,
              ReportSelectOption:[],
              ReportSelectId:"0",
              ReportUrl:"",
              OriginalReportUrl:"",
              langid:localStorage.getItem("currentLangId"),
       }
    },
    computed: {
        ReportLang()
        {
          switch (this.langid) {
                case "1252":
                return "eng";
                case "950":
                return "trad";
                case "936":
                return "simp";
                default:
                return "eng";
            }
        },

    },
    methods: {
        HideSideBar()
        {
            this.showIframe=false;
            this.$emit('changeIframeStrus',this.showIframe)
        },
        GetData()
        {
            this.showIframe=true;
            this.ReportSelectId="0";
            this.ReportSelectOption=[];
            var lastIndex = this.reportIframeItem.LastUpdate.lastIndexOf(' ');
            var startStr =this.reportIframeItem.LastUpdate.substring(0,lastIndex);
            var endStr =this.reportIframeItem.LastUpdate.substring(lastIndex);
            var New ="Last revised at "+ startStr + " by " + endStr;
            this.ReportSelectOption.push({id:"0",label:this.$t('lbl_EMPBE_ReportAll_component_IframeReport_Select',{name:endStr,timer:startStr})})
            if(this.isSuperAdmin){
                //[20092024][SJP] Isaac's request, hide for general sales
                this.ReportSelectOption.push({id:"1",label:this.$t('lbl_EMPBE_ReportAll_component_Export_Original')})
            }       
            this.ReportUrl = `${process.env.VUE_APP_EMP_VIEW}report/`+this.ReportLang+"/"+this.reportIframeItem.EmpCompanyId+"/"+this.reportIframeItem.ReportEdition+"?IsAdminShow=true"
            this.OriginalReportUrl=this.ReportUrl;
        }
    },
    watch:{
        ReportSelectId()
        {
          this.ReportUrl = this.OriginalReportUrl  + "&IsGetRawData="+this.ReportSelectId;
        },
        showIframe(){
            this.$emit('changeIframeStrus',this.showIframe)
        }
       
    }
}
</script>
<style lang="css" >
    #ReportIframeBody .b-sidebar {
        min-width: 800px !important;
        width: 62% !important;
}
    .btnStyle
    {
        position: absolute;
        top: 20px;
        right: 20px;
    }
</style>
